import axios from "axios";
import Joi from 'joi-browser';
import queryString from 'query-string';
import { APIAddress } from "constants/config";

const PARAM = ['all', 'teacherOnly']
const STATES = ['draft', 'published', 'all']

export const schema = Joi.object().keys({
	schoolId: Joi.number().integer().required(),
	param: Joi.string().valid(PARAM).required(),
	amount_per_page: Joi.number().integer().required(),
	page_number: Joi.number().integer().required(),
	state: Joi.string().valid(STATES).allow(''),
  order_by: Joi.number().allow(''),
  title_keyword: Joi.string().allow('')
});

export default function getAnnouncementList(obj) {

  if(!obj.schoolId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school Id')
      })
    })
  }

  let validateResult = Joi.validate(obj, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

	let query = queryString.stringify({
		state: STATES.indexOf(obj.state) >= 0 && STATES.indexOf(obj.state) <= 1 ? STATES.indexOf(obj.state) : undefined,
    order_by: obj.order_by,
    title_keyword: obj.title_keyword
	});

	let param = PARAM.indexOf(obj.param)


  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/g_announce_lst/${obj.schoolId}/${param}/${obj.amount_per_page}/${obj.page_number}?${query}`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/announcement/getAnnouncementList.js